export enum ReportingAction {
  QUOTEDAVAILABILITY = 'QuotedAvailability',
  QUOTE = 'Quote',
  BOOKING = 'Booking',
}
